import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-page-indicator',
  templateUrl: './page-indicator.component.html',
  styleUrls: ['./page-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageIndicatorComponent {
  @Input({ required: true }) currentPage!: number;
  @Input({ required: true }) totalPages!: number;

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i);
  }
}
